import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CandidatService {
  imageUploadHeader: HttpHeaders;
  constructor(private http: HttpClient) {}
  upadateCandidat(body: any, id: any): Observable<any> {
    return this.http.put(`${environment.api.BASE_URL}/candidats/${id}`, body);
  }
  candidatureFilter(body: any, establishmentId: number): Observable<any> {
    return this.http.post(
      `${environment.api.BASE_URL}/etablissements/${establishmentId}/filter`,
      body
    );
  }
  getCondidatById(id: any, afterlogin: boolean = false): Observable<any> {
    const afterloginParam = afterlogin ? '?afterLogin=true' : '';
    return this.http.get(
      `${environment.api.BASE_URL}/candidats/${id}${afterloginParam}`
    );
  }
  missionAndPlanning(id: any): Observable<any> {
    return this.http.get(`${environment.api.BASE_URL}/candidat/planning/${id}`);
  }
  uploadFileCandidat(body: any, id: any) {
    return this.http.post(
      `${environment.api.BASE_URL}/candidats/files/upload/${id}`,
      body
    );
  }
  deleteFile(id: any, fileName: any) {
    return this.http.delete(
      `${environment.api.BASE_URL}/candidats/${id}/files/delete/${fileName}`
    );
  }
  filterPermanat(body: any) {
    return this.http.post(`${environment.api.BASE_URL}/filter`, body);
  }
  getFilterPermanat(id: any) {
    return this.http.get(`${environment.api.BASE_URL}/filter/${id}`);
  }

  getCandidatDetailByIdEstaId(candidatId: any, establishmentId: number): Observable<any> {
    return this.http.get(`${environment.api.BASE_URL}/candidats/${candidatId}?establishmentId=${establishmentId}`);
  }

  getCandidatDetailByIdEstaIdV2(candidatId: any, establishmentId: number = 0, afterlogin = false): Observable<any> {
    const afterloginParam = afterlogin ? '&afterLogin=true' : '';
    return this.http.get(`${environment.api.BASE_URL}/v2/candidats/${candidatId}?establishmentId=${establishmentId}${afterloginParam}`);
  }

  getEvaluationByCandidatId(candidatId: any): Observable<any> {
    return this.http.get(`${environment.api.BASE_URL}/missions/evaluation/candidat/${candidatId}`);
  }
}
